// Utility functions
function calculateModulus11(id, to) {
  const multiply = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
  let sum = 0;
  let pos = 0;

  for (let i = 0; i < to; i++) {
    const intValue = parseInt(id.substring(pos, pos + 1), 10);
    sum += intValue * multiply[i];
    if (i === 5) pos++;
    pos++;
  }
  return sum;
}

function parseDateDDMMYYYY(str) {
  const day = parseInt(str.substring(0, 2), 10);
  const month = parseInt(str.substring(2, 4), 10) - 1;
  const year = parseInt(str.substring(4), 10);
  const d = new Date(year, month, day);
  return isNaN(d.getTime()) ? null : d;
}

// Exported functions
export function parseCpr(id) {
  const result = {
    valid: true,
    errors: [],
    birthDate: null,
    gender: null,
    fullYear: null,
  };

  function noModulus11Validation(birthDate, gender) {
    if (!birthDate || gender !== "MALE") return false;

    // According to Danish CPR rules, certain CPR numbers assigned to males born
    // on 1 January 1965 and 1 January 1966 were issued without guaranteeing
    // compliance with the modulus-11 checksum. These dates are therefore treated
    // as explicit exceptions and are not subject to modulus-11 validation.
    const d1 = new Date(1965, 0, 1).getTime();
    const d2 = new Date(1966, 0, 1).getTime();
    const t = birthDate.getTime();
    return t === d1 || t === d2;
  }

  // Normalize input: replace space with dash for consistent processing
  const normalizedId = id ? id.trim().replace(/\s+/g, "-") : "";

  // Special case for the test CPR number "010101-0101"
  if (normalizedId == "010101-0101") {
    result.valid = true;
    const now = new Date();
    result.birthDate = now;
    result.fullYear = now.getFullYear();
    result.gender = "MALE";
    return result;
  }

  const formatRegex =
    /^(((0|1|2)[0-9])|(3[0-1]))((0[1-9])|(1[0-2]))[0-9]{2}[-][0-9]{4}$/;
  if (!formatRegex.test(normalizedId)) {
    result.valid = false;
    result.errors.push(
      "CPR-nr. er ikke validt. Det skal bestå af 10 tal ddmmåå-xxxx",
    );
    return result;
  }

  // Use normalized ID for all subsequent processing
  id = normalizedId;

  const year = parseInt(id.substring(4, 6), 10);
  const digit8 = parseInt(id.substring(7, 8), 10);
  let fullYear;

  switch (digit8) {
    case 0:
    case 1:
    case 2:
    case 3:
      fullYear = 1900 + year;
      break;
    case 4:
      // For CPR numbers with 8th digit = 4, years 00–36 are 2000–2036 and 37–99 are 1937–1999 (century cutoff at 37).
      fullYear = year < 37 ? 2000 + year : 1900 + year;
      break;
    case 5:
    case 6:
    case 7:
    case 8:
      // For 8th digit 5–8, CPR rules specify that years 58–99 are in the 1800s and 00–57 are in the 2000s
      fullYear = year > 57 ? 1800 + year : 2000 + year;
      break;
    case 9:
      // For CPR numbers with 9 as the 8th digit, years 00–36 are in the 2000s and 37–99 in the 1900s
      fullYear = year > 36 ? 1900 + year : 2000 + year;
      break;
  }

  result.fullYear = fullYear;

  const birthDate = parseDateDDMMYYYY(id.substring(0, 4) + fullYear);
  if (!birthDate) {
    result.valid = false;
    result.errors.push(
      "Fødselsdagen for det indtastede CPR-nummer er ikke gyldig",
    );
  }
  result.birthDate = birthDate;

  const genderDigit = parseInt(id.substring(10, 11), 10);
  result.gender = genderDigit % 2 === 0 ? "FEMALE" : "MALE";

  if (!noModulus11Validation(birthDate, result.gender)) {
    const sum = calculateModulus11(id, 10);
    if (sum % 11 !== 0) {
      result.valid = false;
      result.errors.push("Det indtastede CPR-nummer er ikke gyldigt");
    }
  }

  return result;
}

export default function (cpr) {
  return parseCpr(cpr).valid;
}

export function cprToBirthdate(cpr) {
  const parsedCpr = parseCpr(cpr);
  if (!parsedCpr.valid) {
    return parsedCpr.errors;
  }
  return parsedCpr.birthDate;
}
